import { formatMoney } from 'accounting';

const renderPrice = (price, currencySymbol = '$')  => price === 0
	// TODO: Ask Blake about this...
	? 'FREE'
	: formatMoney(price / 100, currencySymbol);

export default renderPrice;
